import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Attach } from '@app/shared/models/attach';

export const IMAGE_EXTENSIONS = ['.jpeg', '.jpg', '.gif', '.tiff', '.png', '.bmp'];

export const PDF_EXTENSION = '.pdf';

@Injectable({
  providedIn: 'root',
})
export class AttachService {
  constructor(private http: HttpClient) {
    this.getModel = this.getModel.bind(this);
  }

  getAttach(attach: Attach): Observable<Blob> {
    return this.http.get(attach.docUrl, { responseType: 'blob' });
  }

  /**
   * возвращает модель, которую необходимо сохранять на сервере при работе с файлами
   */
  getModel(attach: Attach): Pick<Attach, 'id' | 'docNum' | 'docName'> {
    return _.pick(attach, ['id', 'docNum', 'docName']);
  }
}
